<template>
  <div class="box8" ref="box8">
    <div class="blockone" ref="block"></div>
    <pageTitle title="7大领域真实项目<br /> 轻松应对不同规模企业开发" />
    <div class="subTitle">
      涉及打车、餐饮、通信、电商、房产等多个热门领域，手把手<br />带你解决企业三高等需求，重要的是这些项目<span
        >全部免费送哦！</span
      >
    </div>
    <div class="item-box" ref="projectBox">
      <div class="item" v-for="(item, index) in subject" :key="index">
        <div
          class="item-top"
          ref="item"
          :style="{
            borderRadius:
              cur == index && showAnswer
                ? '0.266667rem 0.266667rem 0rem 0rem '
                : '0.266667rem',
          }"
          @click="changeCur(index)"
        >
          <div class="left">
            <div class="item-title">
              <span>{{ item.title }}</span>
              {{ item.name }}
            </div>
            <p :class="{ warp: cur == index && showAnswer }">{{ item.tit }}</p>
          </div>
          <div
            class="icon"
            :class="{ 'img-rotate': cur == index && showAnswer }"
          >
            <img src="../../assets/common/icon-down.png" alt />
          </div>
          <div
            class="tipsIcon"
            :class="[ruleshow ? 'hidden' : 'show']"
            @click.stop="flag = true"
            v-show="showtips"
            id="tips"
          ></div>
        </div>
        <div
          class="answer"
          :class="{ 'show-answer': cur == index && showAnswer }"
        >
          <div class="line"></div>
          <div class="tag">就业优势</div>

          <div class="superiority">
            <div class="text">
              <p v-for="i in item.employment" :key="i">{{ i }}</p>
            </div>
            <div class="img-box" @click="prveImg(index)">
              <p>点击查看大图</p>
              <img
                :src="
                  require(`../../assets/architect/box8/0${
                    index + 1
                  }.png`)
                "
                alt
              />
            </div>
          </div>

          <div class="tag">业务优势</div>
          <div class="targe">
            <p>{{ item.business }}</p>
          </div>

          <div class="tag">技术优势</div>
          <div class="targe">
            <p v-for="k in item.technology" :key="k">{{ k }}</p>
          </div>

          <div class="tag">涵盖的业务解决方案</div>
          <div class="targe">
            <p v-if="item.p1 !== ''">{{ item.p1 }}</p>
            <p
              class="block-p"
              v-for="j in item.programme"
              :key="j"
              v-html="j"
            ></p>
          </div>

          <div class="tag">学习收获</div>
          <div class="targe target2">
            <p v-for="l in item.harvest" :key="l">{{ l }}</p>
          </div>

          <!-- <div class="answer-btn" v-if="item.link !== ''" @click="toLink(item)">在线真实项目体验</div> -->
        </div>
      </div>
    </div>
    <Modal v-show="flag" @closeModal="closeModal" />
    <previewImage
      :list="list"
      @close="close"
      :clickedIndex="clickedIndex"
      :isPreview="isPreview"
    />
    <div class="btn" @click="childMethod">立即线上体验</div>
  </div>
</template>

<script>
import pageTitle from "../../components/common/pageTitle.vue";
import previewImage from "../../components/common/previewImage.vue";
import Modal from "./modal.vue";
export default {
  components: {
    previewImage,
    pageTitle,
    Modal,
  },
  mounted() {
    this.handleScroll();
  },

  data() {
    return {
      show: false,
      flag: false,
      cur: -1,
      oldScrollTop: 0, //记录上一次滚动结束后的滚动距离
      scrollTop: 0, // 记录当前的滚动距离
      ruleshow: false,
      subject: [
        {
          title: "项目一",
          name: "黑马顺风车",
          tit: "涵盖打车业务场景中的真实需求，带你熟知顺风车业务，以及此类系统的架构设计方案。",
          link: "",
          employment: [
            "打车业务已经渗透的我们生活的方方面面。所谓衣食住行，作为当前最为便捷的出行方式之一，顺风车领域用户量激增，对此类业务的系统要求也越来越高。",
            "这就需要我们开发人员熟知顺风车业务，以及此类系统的架构设计方案。",
          ],
          business:
            "涵盖打车业务场景中的真实需求，应用合理的中间件及巧妙设计，轻松解决GEO、路径匹配、Web即时通讯等互联网前沿业务需求面临的痛点。",
          technology: [
            "采用微服务架构体系、集成Redis、消息队列等中间件。活学活用将架构课中的知识落地到真实的业务开发中去。",
          ],
          programme: [
            "实名认证接入",
            "海量文件存储",
            "OpenCV机器视觉技术",
            "OCR系统接入",
            "⽹⻚即时通讯",
            "微信支付",
            "平台数据大屏",
          ],
          harvest: [
            "1. 掌握实名认证领域的相关知识",
            "2. 掌握⽹站分布式⽂件存储设计",
            "3. 了解OpenCV在Java图像处理领域的应⽤",
            "4. 掌握Redis GEO在距离计算上的应⽤",
            "5. 掌握基于WebSocket的⽹⻚即时通讯设计",
            "6. 掌握⽀付系统的接⼊流程",
            "7. 学会使⽤多渠道数据采集，完成数据⼤屏的展示",
          ],
        },
        {
          title: "项目二",
          name: "DevOps实战",
          tit: "使用主流运维技术实现CI/CD，轻松掌握软件开发到部署的整条生态链路。",
          link: "",
          employment: [
            "微服务大行其道的今天，DevOps技能也跟随企业需求水涨船高，成了考验互联网开发人员的最主要的加分项。",
          ],
          business:
            "贴近企业部署场景，适用于任意企业互联网项目的上云操作，并使用主流运维技术实现CI/CD，轻松掌握软件开发到部署的整条生态链路。",
          technology: [
            "基于Docker、K8S搭建完善的企业云平台，轻松解决项目容器化难题。运用Jenkins完美搭配软件开发流程，杜绝掉企业中无效冗杂的人肉运维操作。",
          ],
          programme: [
            "Docker+K8S云环境搭建",
            "KubeSphere一站式部署",
            "DevOps自动化部署",
            "微服务上云全程剖析",
          ],
          harvest: [
            "1. 掌握基本的Docker+K8S环境搭建",
            "2. 掌握KubeSphere企业云环境的安装与使用",
            "3. 学会DevOps自动化运维的常用技术栈",
            "4. 掌握微服务网站架构上云的技术手段",
            "5. 学会从0到1实现微服务项目的上云",
          ],
        },
        {
          title: "项目三",
          name: "餐掌柜",
          tit: "实现了一线智慧餐厅从点餐、用餐、统计全功能设计，学完即可独立开发智慧餐厅平台。",
          link: "https://pip.itcast.cn/eatManager",
          employment: [
            "随着互联网的不断发展，餐饮行业正在向着信息化以及智慧化方向运营，加之外卖行业规模不断扩大，需要大量开发人员才可以满足日益增长的开发需求。",
          ],
          business:
            "多场景覆盖，多端融合业务体系，还原企业真实业务场景，让你掌握复杂业务逻辑的技术实现技巧，开发事半功倍。",
          technology: [
            "互联网大厂主流微服务架构设计，让架构师都“脸红”的消息分发处理架构。",
          ],
          programme: [
            "应对多个场景的企业开发难题，不仅让你一一掌握，还让你工作时，拿来即用：",
            "多租户系统隔离",
            "海量数据检索",
            "数据增量同步",
            "云打印",
            "多人同步点餐",
          ],
          harvest: [
            "1. 掌握SaaS系统中数据隔离技术",
            "2. 掌握市场主流的Spring Cloud Alibaba Dubbo微服务架构",
            "3. 全面掌握商用级SaaS餐饮系统业务架构以及技术架构",
          ],
        },
        {
          title: "项目四",
          name: "黑马头条",
          tit: "实现某日头条、某讯新闻、某浪新闻三大资讯巨头产品的核心功能，学完即可开发属于你的资讯产品！",
          link: "https://pip.itcast.cn/black?javaeezly",
          employment: [
            "移动互联网时代，资讯系统已广泛应用于各大领域，许多产品都已加入资讯信息模块，掌握资讯类产品功能开发。你可以完成许多行业的资讯业务实现。",
          ],
          business:
            "从移动端、自媒体端到管理后台，完善的业务体系，还原企业真实业务场景，让你掌握复杂业务逻辑的技术实现技巧。",
          technology: [
            "互联网大厂主流微服务架构设计，让你掌握SpringCloud等技术。",
          ],
          p1: "应对多个场景的企业开发难题，不仅让你一一掌握，并让你工作时，拿来即用：",
          programme: [
            "掌握延迟任务定时发布",
            "CMS审核发布",
            "热点数据筛选与处理",
            "静态模板集成",
          ],
          harvest: [
            "1. 掌握类似于今日头条等主要业务功能实现技术",
            "2. 掌握SpringCloud微服务技术",
            "3. 掌握后台CMS内容管理系统开发模式，复用性高",
            "4. 掌握项目DevOps技能，增加自身竞争力",
          ],
        },
        {
          title: "项目五",
          name: "闪聚支付",
          tit: "整合了全渠道支付收款、账户管理、账号管理等服务于一体，学完即可胜任聚合支付类项目工作。",
          link: "https://pip.itcast.cn/java-sjb?javaeezly",
          employment: [
            "移动支付已成为我国消费支付的主流方式。而聚合支付将多个支付平台合并到一个平台上，只需要一个码便可以就把支付环节搞定，相对于微信、支付宝或银联支付，它更省时省力。学完本项目，具备聚合支付的开发能力。",
          ],
          business:
            "完整聚合支付体系，还原企业真实业务场景，让你掌握复杂业务逻辑的技术实现技巧，开发事半功倍。",
          technology: [
            "基于Spring Cloud Alibaba微服务架构，实现项目的快速开发并和企业应用无缝对接。",
          ],
          p1: "4大方案，应对多个场景的企业开发难题，不仅让你一一掌握，并让你工作时，拿来即用：",
          programme: [
            "Druid实时分析型数据库",
            "Sentinel熔断限流",
            "Sharding-jdbc",
            "XXL-JOB分布式任务调度平台",
          ],
          harvest: [
            "1. 掌握支付行业聚合支付应用核心功能的实现技术",
            "2. 精通市场主流的Spring Cloud Alibaba微服务全家桶",
          ],
        },
        {
          title: "项目六",
          name: "Drools规则引擎",
          tit: "规则引擎实现了将业务决策从应用程序代码中分离出来，接收数据输入，解释业务规则，并根据业务规则做出业务决策。",
          link: "",
          employment: ["掌握Drools可以让你在遇到规则类业务时有件趁手的工具。"],
          business: "业务规则与系统代码分离，可随时对业务规则进行扩展和维护。",
          technology: ["从执行流程，语法，案例实现，剖析Drools规则引擎。"],
          programme: ["个人所得税计算", "银行信用卡申请"],
          harvest: [
            "1. 能够搭建Drools开发环境",
            "2. 能够掌握Drools规则文件的构成部分",
            "3. 能够掌握Spring整合Drools过程",
            "4. 能够将Drools应用到实战中",
          ],
        },
        {
          title: "项目七",
          name: "好客租房",
          tit: "好客租房是一个无中介化房屋租赁平台。包含房源智能推荐、地图找房、行情查询、电子合同、限时秒杀等功能。",
          link: "",
          employment: [
            "租房行业与生活息息相关，本项目实现了房源智能推荐、地图找房、行情查询、电子合同、限时秒杀等功能。通过本课程的学习，可以完成一个完整的前端+后端+小程序全终端应用开发。",
          ],
          business:
            "通过本课程的学习，可以实现移动web应用、微信小程序应用、后台管理应用等功能，完成一个完整的前端+后端+小程序全终端应用项目。",
          technology: [
            "基于SOA思想进行架构",
            "使用GraphQL接口通信",
            "集成微信小程序",
            "整合大数据相关技术",
            "引入分布式事务的解决方案",
          ],
          programme: [
            "前后端分离工程构建解决方案（Reactjs+Ant Design<br/>+Node.js+Npm+webpack)",
            "SOA解决方案（Dubbo)",
            "Spring全家桶解决方案（SpringBoot+SpringData）",
            "分布式消息/事务解决方案（RocketMQ）",
            "分布式搜索服务解决方案（Elasticsearch）",
            "大数据存储解决方案（mongoDB）",
            "微信授权登录解决方案（微信小程序）",
            "前后端分析接口服务解决方案（RESTful+GraphQL）",
            "云存储解决方案（OSS)",
            "爬虫解决方案（webmagic）",
            "即时通信解决方案（WebSocket)",
            "容器化解决方案(Docker)",
          ],
          harvest: [
            "1. 全面掌握ReactJS技术在项目中的应用",
            "2. 通过GraphQL解决RESTful方式服务资源浪费问题",
            "3. 使用WebSocke实现即时通讯",
            "4. 掌握微信小程序技术，完成平台多样化开发",
            "5. 通过Elaststack技术栈，轻松搞定数据的收集、存储、展现",
            "6. 掌握MongoDB集群、MySQL集群、Redis集群等相关的集群技术",
          ],
        },
      ],
      isPreview: false,
      list: [
        {
          img: null,
          id: 0,
        },
      ],
      showAnswer: false,
      clickedIndex: 0,
      prevItemHeight: 0,
      showtips: false,
    };
  },

  methods: {
    goTop(index) {
      window.scrollTo(
        0,
        this.$refs.item[index].offsetTop -
          this.$refs.block.offsetHeight -
          this.$refs.block.offsetHeight * 0.3 -
          this.prevItemHeight
      );
    },
    handleScroll() {
      const viewPortHeight =
        window.innerHeight || document.documentElement.clientHeight;
      window.addEventListener("scroll", () => {
        this.scrollTop = window.scrollY;
        if (
          (this.$refs.box8?.offsetTop - this.scrollTop <= viewPortHeight-(7.2 * this.$refs.block.offsetHeight) )
           && (this.$refs.box8?.offsetTop+this.$refs.box8?.offsetHeight - this.scrollTop >= viewPortHeight-(5.9 * this.$refs.block.offsetHeight))
        ) {
          this.showtips = true;
        } else {
          this.showtips = false;
        }
      });
    },
    closeModal() {
      this.flag = false;
    },
    changeCur(index) {
      const a = document.querySelector(".show-answer");
      if (a != null && index > this.cur) {
        this.prevItemHeight = a.offsetHeight;
      }
      if (!this.showAnswer || index <= this.cur) {
        this.prevItemHeight = 0;
      }
      if (index == this.cur) {
        this.showAnswer = !this.showAnswer;
      } else {
        this.showAnswer = true;
        this.cur = index;
      }
      this.goTop(index);
    },
    toLink(item) {
      window.open(item.link);
    },
    close() {
      this.isPreview = false;
    },
    prveImg(index) {
      this.list[0].img = require(`../../assets/architect/box8/0${
        index + 1
      }.png`);
      this.isPreview = true;
    },
    childMethod() {
      this.$parent.itcastClick();
    }
  },
  watch: {
    scrollTop(newValue, oldValue) {
      setTimeout(() => {
        if (newValue == window.scrollY) {
          //延时执行后当newValue等于window.scrollY，代表滚动结束
          this.ruleshow = false;
          this.oldScrollTop = newValue; //每次滚动结束后都要给oldScrollTop赋值
        }
      }, 200); //必须使用延时器，否则每次newValue和window.scrollY都相等，无法判断，20ms刚好大于watch的侦听周期，故延时20ms
      if (this.oldScrollTop == oldValue) {
        //每次滚动开始时oldScrollTop与oldValue相等
        this.ruleshow = true;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.ruleshow); //离开当前组件别忘记移除事件监听哦
  },
};
</script>

<style lang="less" scoped>
.box8 {
  padding: 0px 0px 80px;
  width: 100%;
  background: #c5ddff;
  .btn{
    width: 400px;
    height: 78px;
    font-size: 34px;
    color: #fff;
    text-align: center;
    line-height: 78px;
    border-radius: 14px;
    background: #ff5627;
    margin: 50px auto 0;
  }
  @keyframes scaleBox {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
    100% {
      transform: scale(1);
    }
  }
  .subTitle {
    font-family: PingFangSC-Regular;
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 40px;
    letter-spacing: 0px;
    text-align: center;
    color: #24375c;
    margin-top: 28px;
    span {
      font-family: PingFangSC-Semibold;
      font-size: 24px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #ff4d24;
    }
  }
  .blockone {
    height: 80px;
  }
  .title {
    margin-bottom: 60px;
    font-family: PingFangSC-Semibold;
    font-size: 40px;
    font-weight: bold;
    text-align: center;
    line-height: 62px;
    letter-spacing: 0px;
    color: #24375c;

    .tit {
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: normal;
      line-height: 40px;
      letter-spacing: 0px;
      color: #24375c;
    }
  }

  .item-box {
    margin: 48px auto 0;
    width: 690px;
    box-sizing: border-box;
    .item {
      margin-bottom: 20px;
      // position: relative;
      // background: #ffffff;

      &:last-child {
        margin-bottom: 0px;
      }
      .item-top {
        display: flex;
        align-items: center;
        justify-content: space-between;

        padding: 40px;
        padding-left: 50px;
        width: 100%;
        min-height: 153px;
        background-color: #ffffff;
        // border-radius: 20px;
        box-sizing: border-box;
        transition: 0.3s ease all;
        position: relative;
        .tipsIcon {
          background: url("../../assets/architect/box8/tip.png")
            no-repeat;
          width: 80px;
          height: 53px;
          background-size: contain;
          position: fixed;
          bottom: 520px;
          right: 15px;
          z-index: 10;
        }
        .hidden {
          right: -65px;
        }
        .show {
          transition: 1s ease animation;
          -webkit-animation: scaleBox 1s infinite ease;
          animation: scaleBox 1s infinite;
        }
        .item-title {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          font-family: PingFangSC-Medium;
          font-size: 28px;
          font-weight: bold;
          line-height: 40px;
          color: #24375c;
          span {
            margin-right: 20px;
            font-family: PingFangSC-Semibold;
            font-size: 28px;
            font-weight: bold;
            line-height: 40px;
            background: linear-gradient(
              270deg,
              #00a8ff 0%,
              #0098ff 50%,
              #008aff 100%
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }

        .icon {
          width: 28px;
          height: 28px;
          transition: 0.5s ease all;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .img-rotate {
          transform: rotate(180deg);
        }
        p {
          width: 548px;
          font-family: PingFang SC;
          font-size: 24px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 40px;
          letter-spacing: 0px;
          color: #485265;

          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
        }

        .warp {
          overflow: unset;
          white-space: normal;
          text-overflow: unset;
          -o-text-overflow: unset;
        }
      }
    }
    .item:nth-child(7) {
      .block-p {
        white-space: nowrap;
      }
    }
    .answer {
      position: relative;
      background: #ffffff;
      box-sizing: border-box;
      border-radius: 0px 0px 20px 20px;
      max-height: 0;
      opacity: 0;
      transition: 0.3s ease all;
      overflow: hidden;
      z-index: 3;
      padding: 0px 32px 8px 32px;
      .line {
        margin-bottom: 32px;
        width: 100%;
        border-top: 1px solid #d3def0;
      }
      .superiority {
        display: flex;
        justify-content: space-between;
        padding-bottom: 40px;

        p {
          font-size: 26px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #4e5969;
          line-height: 44px;
        }

        .img-box {
          flex-shrink: 0;

          width: 200px;
          height: 128px;
          border: 4px solid #fff;
          box-shadow: 0px 24px 60px 0px rgba(94, 123, 218, 0.1),
            0px 12px 24px -16px rgba(94, 123, 218, 0.16);
          object-fit: contain;
          overflow: hidden;
          position: relative;
          p {
            position: absolute;
            bottom: 0px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 152px;
            height: 40px;
            background: rgba(27, 27, 27, 0.7);
            border-radius: 0px 24px 0px 0px;

            font-size: 20px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #ffffff;
          }

          img {
            width: 100%;
            height: 100%;
            border-radius: 10px;
          }

          .img1 {
            width: 100%;
            height: 250%;
          }
        }
      }

      .targe {
        padding-bottom: 40px;
        .block-p {
          position: relative;
          margin-left: 25px;

          &::before {
            content: "";
            display: block;
            width: 4px;
            height: 4px;
            background: #86909c;
            position: absolute;
            left: -22px;
            top: 18px;
            border-radius: 50%;
          }
        }
        p {
          font-size: 26px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #4e5969;
          line-height: 44px;
        }
      }
      .target2 {
        padding-left: 33px;
        text-indent: -33px;
      }
      .answer-btn {
        // margin: 0 auto;
        margin: 30px auto;
        width: 352px;
        height: 60px;
        text-align: center;
        font-family: PingFangSC-Medium;
        font-size: 26px;
        color: #ffffff;
        line-height: 60px;
        border-radius: 28px;
        background: linear-gradient(90deg, #34abfd 0%, #426de5 100%);
      }
    }
    .show-answer {
      padding: 0px 32px 8px 32px;
      // display: block;
      max-height: 2400px;
      opacity: 1;
      transition: 0.4s ease all;
    }

    .tag {
      height: 52px;
      background: #e6f4ff;
      border-radius: 0px 32px 32px 24px;
      width: max-content;
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #0195ff;
      line-height: 52px;
      padding: 0 24px;
      margin-bottom: 24px;
    }
  }
}
</style>
